module.exports = __webpack_public_path__ + "media/images/area/popular/nikko-6bd8d29df16dfd26439ab769b2a8d1e6.jpg";